import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Container, Col, Row } from 'virtues-bootstrap';
import Logo from './Logo';

import s from './styles.module.scss';

class CommonHeader extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
  };

  static defaultProps = {
    children: null,
  };

  render() {
    const { children } = this.props;

    return (
      <div className={s.header}>
        <Container>
          <Row className={s.verticalCentring}>
            <Col xs={3}>
              <Logo />
            </Col>
            {children}
          </Row>
        </Container>
      </div>
    );
  }
}
export default CommonHeader;
